import type { UseFormSetError } from 'react-hook-form';

import type { ErrorObjectArray } from '@liscio/api';

import type { CreateAccountFormValues } from './createAccountValidationSchema';

const FIELD_ERROR_PATTERNS: Array<{
  field: keyof CreateAccountFormValues;
  pattern: RegExp;
}> = [
  { field: 'name', pattern: /\bname\b/i },
  { field: 'entity_type', pattern: /\bentity(?:[_\s-])type\b/i },
  { field: 'status', pattern: /\bstatus\b/i },
  { field: 'stage', pattern: /\bstage\b/i },
];

/**
 * Maps V5 `422` error payloads onto form fields when the message mentions a field.
 */
export function applyCreateAccountApiErrors(
  error: ErrorObjectArray,
  setError: UseFormSetError<CreateAccountFormValues>
): string {
  const messages =
    error.errors?.map((entry) => entry.message).filter(Boolean) ?? [];

  if (messages.length === 0) {
    return 'Unable to create account. Please try again.';
  }

  messages.forEach((message) => {
    const match = FIELD_ERROR_PATTERNS.find(({ pattern }) =>
      pattern.test(message ?? '')
    );

    if (match) {
      setError(match.field, { type: 'server', message: message ?? '' });
    }
  });

  return messages[0] ?? 'Unable to create account. Please try again.';
}
